import styled from "styled-components/macro";

export const FnrToggleTitle = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  color: #828c8d;
  font-weight: 400;
  line-height: 15px;
  padding: 2px 5px;
  padding-bottom: 0;
  z-index: 100;
`;
